// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "21b273d5","34826": "b14e25c1","43287": "0297729b","53319": "22e13425","60238": "7ad9aa9e","83130": "91394924",}[chunkId] + ".css"
}